import { StyleSheet } from 'aphrodite';
import { THEME } from '../../../components-v2/Theme/theme';

export const styleSheet = StyleSheet.create({
	container: {
		alignItems: 'center',
		border: THEME.common.border,
		borderRadius: THEME.common.borderRadius,
		display: 'flex',
		flexWrap: 'wrap',
		gap: THEME.spacing.md,
		justifyContent: 'space-between',
		padding: THEME.spacing.md,
	},
	actions: {
		alignItems: 'center',
		display: 'flex',
		flexShrink: 0,
		gap: THEME.spacing.sm,
	},
	dismissButton: {
		color: THEME.colors.text.light,
	},
	info: {
		display: 'flex',
		flex: '1 1 auto',
		flexDirection: 'column',
		gap: THEME.spacing.xs,
		minWidth: 0,
	},
	title: {
		color: THEME.colors.text.main,
		fontSize: THEME.typography.fontSizes.md,
		fontWeight: THEME.typography.fontWeights.bold,
	},
	description: {
		color: THEME.colors.text.light,
		fontSize: THEME.typography.fontSizes.sm,
		maxWidth: 560,
	},
	statusRow: {
		alignItems: 'flex-start',
		display: 'flex',
		gap: THEME.spacing.sm,
		marginTop: THEME.spacing.xs,
		minWidth: 0,
	},
	statusText: {
		color: THEME.colors.text.main,
		fontSize: THEME.typography.fontSizes.sm,
		...THEME.common.truncate,
	},
	loading: {
		alignItems: 'center',
		display: 'flex',
		gap: THEME.spacing.sm,
		padding: THEME.spacing.md,
	},
});
